import React from 'react';
import { FadeIn, SectionTitle, Card, Tag } from '../components/UI';

const PROJECTS = [
  {
    client: 'National Logistics Provider',
    title: 'Cloud Migration to Azure',
    tags: ['Azure', 'Infrastructure', 'DevOps'],
    desc: 'Migrated 40+ on-premises servers to Azure, reducing infrastructure costs by 35% and improving uptime to 99.99%. Implemented Azure DevOps pipelines for automated deployments.',
    outcome: '35% cost reduction, 99.99% uptime',
  },
  {
    client: 'Financial Services Firm',
    title: 'Bespoke Client Portal',
    tags: ['.NET', 'React', 'SQL Server', 'Azure'],
    desc: 'Designed and built a secure client-facing portal enabling real-time portfolio viewing, document management, and secure messaging. .NET 8 API with React frontend on Azure App Services.',
    outcome: '60% reduction in client enquiries',
  },
  {
    client: 'Healthcare Organisation',
    title: 'Disaster Recovery Implementation',
    tags: ['DR Planning', 'Azure', 'Infrastructure'],
    desc: 'Designed and implemented a comprehensive disaster recovery solution including geo-redundant backups, automated failover, and documented recovery procedures. Achieved sub-4-hour RTO.',
    outcome: 'Sub-4-hour recovery time objective',
  },
  {
    client: 'Retail Chain (25 Locations)',
    title: 'Bespoke Inventory System',
    tags: ['Internal Systems', '.NET', 'SQL Server'],
    desc: 'Replaced spreadsheet-based stock management with a custom-built inventory and ordering system. Real-time stock levels across all locations with automated reorder triggers.',
    outcome: '30% reduction in stock discrepancies',
  },
  {
    client: 'Property Management Company',
    title: 'Legacy System Modernisation',
    tags: ['Web Design', '.NET', 'Azure'],
    desc: 'Replaced a 15-year-old desktop application with a modern web-based platform. Migrated data from Access databases to SQL Server with new .NET APIs and a responsive web interface.',
    outcome: 'Modern platform, 10x faster reporting',
  },
  {
    client: 'Education Sector',
    title: 'IT Strategy & Roadmap',
    tags: ['IT Strategy', 'Consulting'],
    desc: 'Developed a 3-year IT strategy aligned with growth plans, including cloud adoption, security improvements, and infrastructure planning. Vendor-neutral advice with ongoing advisory support.',
    outcome: 'Clear 3-year technology roadmap',
  },
];

export default function PortfolioPage() {
  return (
    <div style={{ paddingTop: 100, background: 'var(--dark)' }}>
      <section style={{ padding: '60px 40px 100px', maxWidth: 1100, margin: '0 auto' }}>
        <FadeIn>
          <SectionTitle subtitle="Our Work" title="Projects we're proud of" />
          <p style={{
            fontFamily: 'var(--font-body)', fontSize: '1.02rem',
            fontWeight: 300, color: 'var(--text-secondary)',
            lineHeight: 1.75, maxWidth: 620, marginBottom: 44,
          }}>
            A selection of recent engagements showcasing the range and depth of
            our work across industries and technologies.
          </p>
        </FadeIn>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 22,
        }}>
          {PROJECTS.map((p, i) => (
            <FadeIn key={i} delay={i * 0.07}>
              <Card style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <p style={{
                  fontFamily: 'var(--font-mono)', fontSize: '0.68rem',
                  color: 'var(--text-muted)', textTransform: 'uppercase',
                  letterSpacing: '0.1em', marginBottom: 8,
                }}>{p.client}</p>

                <h3 style={{
                  fontFamily: 'var(--font-body)', fontSize: '1.12rem',
                  fontWeight: 600, color: 'var(--text-primary)', marginBottom: 10,
                }}>{p.title}</h3>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                  {p.tags.map((t, j) => <Tag key={j} blue>{t}</Tag>)}
                </div>

                <p style={{
                  fontFamily: 'var(--font-body)', fontSize: '0.88rem',
                  fontWeight: 300, color: 'var(--text-secondary)',
                  lineHeight: 1.65, flex: 1,
                }}>{p.desc}</p>

                <div style={{
                  marginTop: 14, paddingTop: 14,
                  borderTop: '1px solid var(--card-border)',
                }}>
                  <p style={{
                    fontFamily: 'var(--font-mono)', fontSize: '0.78rem',
                    color: 'var(--cyan)',
                  }}>✓ {p.outcome}</p>
                </div>
              </Card>
            </FadeIn>
          ))}
        </div>
      </section>
    </div>
  );
}
